<ng-container *transloco="let t">
  <div class="team-list-item">
    <div class="team-list-item__logo">
      <img src="assets/img/bg3.jpg" alt="" class="event-logo">
    </div>
    <div class="team-list-item__description">
      <div class="fw-bold fs-18-16 team-list-item__title">
        Atletski klub SLJEME
      </div>
      <ng-content></ng-content>
    </div>
  </div>
</ng-container>
